import React, { useMemo } from "react";
import EpisodesSkeleton from "./EpisodesSkeleton";

const EpisodeSectionSkeleton: React.FC = () => {
  const screenWidth = window.innerWidth;

  const getSkeletonArray = useMemo(() => {
    return screenWidth < 768 ? [1, 2] : [1, 2, 3, 4, 5, 6];
  }, [screenWidth]);

  const getEpisodesSkeletonArray = useMemo(() => {
    if (screenWidth < 768) return [1];
    if (screenWidth < 1280) return [1, 2];
    return [1, 2, 3];
  }, [screenWidth]);

  const gridClass = useMemo(() => {
    if (screenWidth < 768) return "grid-cols-1 mx-auto";
    if (screenWidth < 1280) return "grid-cols-2";
    return "grid-cols-3";
  }, [screenWidth]);

  return (
    <div>
      <div className="flex gap-6 mb-7">
        {getSkeletonArray.map((val) => (
          <div className="skeleton w-[118px] h-10" key={val}></div>
        ))}
      </div>

      <div className={`grid ${gridClass} gap-8 items-start z-[1] mt-6`}>
        {getEpisodesSkeletonArray.map((val) => (
          <EpisodesSkeleton key={val} />
        ))}
      </div>
    </div>
  );
};

export default EpisodeSectionSkeleton;
